export default "__VITE_ASSET__83493e40__"